// Define the API base URL
// Development
// export const AUTH_URL = 'http://localhost:8080/api/v1'
// export const TOSK_URL = 'http://localhost:8081/api/v1'

// Production
export const AUTH_URL = 'https://raitatosk.com/authservice/api/v1'
export const TOSK_URL = 'https://raitatosk.com/toskservice/api/v1'
